import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
export default (function (coinType) {
  return function (Origin) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(Coin, _PureComponent);

      var _super = _createSuper2(Coin);

      function Coin(props) {
        var _this;

        _classCallCheck(this, Coin);

        _this = _super.call(this, props);
        _this.isFocus = void 0;
        _this.mouseDown = void 0;
        _this.state = {
          showCoin: props.coin
        };
        _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
        _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
        _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
        _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(Coin, [{
        key: "getValue",
        value: function getValue() {
          var showCoin = this.state.showCoin;
          var value = this.props.value;

          if (showCoin && (value || value === 0)) {
            return "".concat(value).replace(/\d+/, function (n) {
              return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                return "".concat($1, ",");
              });
            });
          }

          if (value === 0) return 0;
          return "".concat(value || '').replace(/,/g, '');
        }
      }, {
        key: "handleFocus",
        value: function handleFocus(e) {
          var onFocus = this.props.onFocus;
          this.isFocus = true;
          this.setState({
            showCoin: false
          });
          if (onFocus) onFocus(e);
        }
      }, {
        key: "handleBlur",
        value: function handleBlur(e) {
          var onBlur = this.props.onBlur;
          this.isFocus = false;
          this.setState({
            showCoin: true
          });
          if (onBlur) onBlur(e);
        }
      }, {
        key: "handleMouseDown",
        value: function handleMouseDown(e) {
          var onMouseDown = this.props.onMouseDown;
          this.mouseDown = true;
          this.setState({
            showCoin: false
          });
          if (onMouseDown) onMouseDown(e);
        }
      }, {
        key: "handleMouseUp",
        value: function handleMouseUp(e) {
          var onMouseUp = this.props.onMouseUp;

          if (this.mouseDown && !this.isFocus) {
            this.setState({
              showCoin: true
            });
          }

          this.mouseDown = false;
          if (onMouseUp) onMouseUp(e);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              coin = _this$props.coin,
              value = _this$props.value,
              onFocus = _this$props.onFocus,
              onBlur = _this$props.onBlur,
              others = _objectWithoutProperties(_this$props, ["coin", "value", "onFocus", "onBlur"]);

          if (!coin) return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              coin: undefined
            }))
          );
          if (coinType === 'input' && this.props.type !== 'number') return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              coin: undefined
            }))
          );
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, others, {
              onMouseDown: this.handleMouseDown,
              onMouseUp: this.handleMouseUp,
              value: this.getValue(),
              onFocus: this.handleFocus,
              onBlur: this.handleBlur,
              coin: true
            }))
          );
        }
      }]);

      return Coin;
    }(PureComponent), _class.defaultProps = {
      coin: false
    }, _temp;
  };
});